export class RankModel {

    /**
     * Constructor
     *
     * @param module
     * @param title
     * @param rank
     * @param total_points
     * @param game_period_nr
     * @param iHash
     */
    public constructor(
        public module: string = null,
        public title: string = null,
        public rank: number = null,
        public total_points: number = 0 ,
        public game_period_nr: number = null,
        public iHash: string = null,
    ) { }
}